// mobile
import { ReactComponent as MoBrunch } from 'assets/images/footer/mobile/brunch.svg';
// mobile
import { ReactComponent as MoLinkedin } from 'assets/images/footer/mobile/linked_in.svg';
import { ReactComponent as MobNewsLetter } from 'assets/images/footer/mobile/news_letter.svg';
import { ReactComponent as MoYoutube } from 'assets/images/footer/mobile/youtube.svg';
import { ReactComponent as WebBrunch } from 'assets/images/footer/web/brunch.svg';
import { ReactComponent as WebLinkedin } from 'assets/images/footer/web/linked_in.svg';
import { ReactComponent as WebNewsLetter } from 'assets/images/footer/web/news_letter.svg';
import { ReactComponent as WebYoutube } from 'assets/images/footer/web/youtube.svg';

import siteConfig from '../../../jsons/menu/site.json';

const orgSchema = siteConfig.pages.main.meta.schema.find(
  (s) => s['@type'] === 'Organization'
);
const sameAsUrls = orgSchema ? orgSchema.sameAs : [];
const getSocialUrl = (domain, defaultUrl) =>
  sameAsUrls.find((url) => url.includes(domain)) || defaultUrl;

export const footerConst = {
  info: [
    {
      className: 'address',
      title: '주소',
      content:
        '경기도 성남시 분당구 판교역로 240 (삼평동 678) 삼환하이펙스 A동 8층, 13493',
    },
    {
      className: 'tel',
      title: '고객센터',
      content: <a href="tel:02-589-9523">02-589-9523</a>,
    },
    {
      className: 'mail',
      title: '메일',
      content: <a href="mailto:impsbiz@inavi.kr">impsbiz@inavi.kr </a>,
    },
  ],
  familySite: [
    {
      title: '아이나비시스템즈',
      type: 'inavisystems',
      url: 'https://www.inavisys.com/',
    },
    {
      title: 'THINKWARE',
      type: 'thinkware',
      url: 'https://www.thinkware.co.kr/',
    },
    {
      title: 'FIVEPIN',
      type: 'fivepin',
      url: 'https://www.fivepin.co.kr/NaviMap/MapMain',
    },
  ],
  social: [
    {
      title: 'INAVI Maps 링크드인',
      type: 'linked-in',
      url: getSocialUrl(
        'linkedin.com',
        'https://www.linkedin.com/showcase/inavimps/'
      ),
      icon: {
        web: <WebLinkedin />,
        mobile: <MoLinkedin />,
      },
      color: '#0077b7',
    },
    {
      title: 'INAVI Maps 유튜브 채널',
      type: 'youtube',
      url: getSocialUrl('youtube.com', 'https://www.youtube.com/@INAVISystems'),
      icon: {
        web: <WebYoutube />,
        mobile: <MoYoutube />,
      },
      color: '#e7332f',
    },
    {
      title: '테크블로그',
      type: 'branch',
      url: getSocialUrl(
        'brunch.co.kr',
        'https://brunch.co.kr/@69b44915359847c'
      ),
      icon: {
        web: <WebBrunch />,
        mobile: <MoBrunch />,
      },
      color: '#ffffff',
    },
    {
      title: '뉴스레터',
      type: 'news-letter',
      url: 'https://inaviletter.stibee.com/',
      icon: {
        web: <WebNewsLetter />,
        mobile: <MobNewsLetter />,
      },
      color: 'transparent',
    },
  ],
};
